import React from 'react';

import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { DEFAULT_REDIRECT_AUTH_ROUTE } from '../../config/Constants';
import { User } from '../../models/User';

type PrivateRouteProps = {
  outlet: JSX.Element;
};

function GuestRoute({ outlet }: PrivateRouteProps) {
  const user: User = useSelector((state: any) => state.auth);

  if (user?.id === 0) {
    return outlet;
  }

  return <Navigate to={DEFAULT_REDIRECT_AUTH_ROUTE} />;
}

export default GuestRoute;
